import { useState, useEffect } from "react";
import { useIdentity } from "base/identity-resolver";
import Decorator from "clientDecorator";
import get from "lodash.get";

const useDynamicFields = (quillRef, contact, isSignatureForm, autoReplaceDynamicFields) => {
  const dynamicFields = [
    "{First Name}",
    "{Last Name}",
    "{Primary Phone}",
    "{Primary Email}",
    "{Your First Name}",
    "{Your Last Name}",
  ];

  const [showDynamicPopup, setShowDynamicPopup] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0, bottom: 0 });
  const [filteredFields, setFilteredFields] = useState(dynamicFields);
  const { user } = useIdentity();

  useEffect(() => {
    if (quillRef && quillRef.current) {
      const quill = quillRef.current.getEditor();

      const handleDynamicFields = () => {
        const text = quill.getText();

        if (!quill.hasFocus()) {
          quill.focus();
        }

        const cursorPosition = quill.getSelection() ? quill.getSelection().index : null;
        const match = text[cursorPosition - 2] + text[cursorPosition - 1];
        let { top, left, bottom } = quill.getBounds(cursorPosition);

        if (isSignatureForm) {
          left += 410;
        }

        if (match === "{{") {
          setPopupPosition({ top, left, bottom });
          setShowDynamicPopup(true);
          setFilteredFields(dynamicFields);
        } else if (showDynamicPopup) {
          const startPos = text.lastIndexOf("{{", cursorPosition) + 2;
          const input = text.slice(startPos, cursorPosition);
          const filtered = dynamicFields.filter((field) => field.toLowerCase().includes(input.toLowerCase()));

          setFilteredFields(filtered);
          setPopupPosition({ top, left, bottom });

          if (filtered.length === 0 || input.trim() === "") {
            setShowDynamicPopup(false);
          } else {
            setShowDynamicPopup(true);
          }
        }

        if (match === "{") {
          setShowDynamicPopup(false);
        }
      };

      quill.on("text-change", handleDynamicFields);

      return () => {
        quill.off("text-change", handleDynamicFields);
      };
    }
  }, [quillRef, dynamicFields, showDynamicPopup, contact, isSignatureForm]);

  const handleFieldClick = (field) => {
    if (quillRef && quillRef.current) {
      const quill = quillRef.current.getEditor();

      if (!quill.hasFocus()) {
        quill.focus();
      }

      let cursorPosition = quill.getSelection() ? quill.getSelection().index : null;

      if (cursorPosition === null) {
        cursorPosition = quill.getLength();
      }

      const text = quill.getText();
      let startPos = text.lastIndexOf("{{", cursorPosition - 1);
      const deleteLength = cursorPosition - startPos;
      quill.deleteText(startPos, deleteLength);

      let fieldValues;
      if (autoReplaceDynamicFields) {
        let userFirstName = "";
        let userLastName = "";
        const nameParts = Decorator.User.getName(user).split(" ");
        userFirstName = nameParts[0];
        userLastName = nameParts[nameParts.length - 1];
        fieldValues = {
          "{First Name}": get(contact, "properties.name_first.value"),
          "{Last Name}": get(contact, "properties.name_last.value"),
          "{Primary Phone}": (() => {
            let primaryPhone = "";
            const { phone } = Decorator.Profile.getPrimaryContactInfo(contact);
            if (phone) primaryPhone = phone.phone;
            return primaryPhone;
          })(),
          "{Primary Email}": (() => {
            let primaryEmail;
            const { email } = Decorator.Profile.getPrimaryContactInfo(contact);
            if (email) primaryEmail = email.email;
            return primaryEmail;
          })(),
          "{Your First Name}": userFirstName,
          "{Your Last Name}": userLastName,
        };
      } else {
        fieldValues = {
          "{First Name}": "{{First Name}}",
          "{Last Name}": "{{Last Name}}",
          "{Primary Phone}": "{{Primary Phone}}",
          "{Primary Email}": "{{Primary}}",
          "{Your First Name}": "{{Your First Name}}",
          "{Your Last Name}": "{{Your Last Name}}",
        };
      }

      const valueToInsert = fieldValues[field];
      if (valueToInsert !== undefined) {
        quill.insertText(startPos, valueToInsert + "");
      }

      setShowDynamicPopup(false);
    }
  };

  return { showDynamicPopup, setShowDynamicPopup, popupPosition, filteredFields, handleFieldClick };
};

export default useDynamicFields;
